<template>
	<b-modal id="pointadjuster" size="sm" :title="`Adjust ${type}`" body-class="text-center" v-model="show" @shown="shown">
		<div class="row">
			<div class="col">
				<b-form-input ref="input" type="number" inputmode="numeric" class="form-control" v-model="value" />
			</div>
		</div>
		<template v-slot:modal-footer>
			<div class="button-group w-100 d-flex justify-content-between">
				<button class="btn btn-danger" @click="decrease()" data-dismiss="modal">Decrease</button>
				<button class="btn btn-primary" @click="reset()" data-dismiss="modal">Reset</button>
				<button class="btn btn-success" @click="increase()" data-dismiss="modal">Increase</button>
			</div>
		</template>
    </b-modal>
</template>

<script>
const ABBR = {
	Resolve: 'RP'
}

export default {
	data: function() {
		return {
			value: '',
		}
	},
	props: {
		type: {
			type: String,
			default: 'Resolve',
		},
	},
	computed: {
		show: {
			get: function() {
				return this.$store.state.modals.numeric.show
			},
			set: function(value){
				this.$store.commit('modals/set','numeric',value)
			}
		},
		valueInt: function() {
			return parseInt(this.value)
		},
		resolve: {
			get: function() {
				return this.$store.state.Character.Current.Points.Resolve
			},
			set: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: 'Current.Points.Resolve',
						val: value,
					}
				])
			}
		},
		maxHP: function() {
			return this.$store.getters['character/status/totalHP']
		},
		maxSP: function() {
			return this.$store.getters['character/status/totalSP']
		},
		maxRP: function() {
			return this.$store.getters['character/status/totalRP']
		}
	},
	methods: {
		shown: function() {
			this.$refs.input.focus()
		},
		increase: function() {
			let newValue = (this.resolve + this.valueInt)
			let maximum = this[`max${ABBR[this.type]}`]

			if( newValue > maximum ){
				newValue = maximum
			}
			this.$store.dispatch( `character/status/set${ABBR[this.type]}`, newValue )
			this.show = false
		},
		decrease: function() {
			let newValue = (this.resolve - this.valueInt)

			if( newValue < 0 ){
				newValue = 0
			}
			this.$store.dispatch( `character/status/set${ABBR[this.type]}`, newValue )
			this.show = false
		},
		reset: function() {
			this.$store.dispatch(`character/status/reset${ABBR[this.type]}`)
			this.show = false
		}
	},
}
</script>

<style scoped>

</style>